import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/States";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading label="Checking session" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
